module.exports = __webpack_public_path__ + "static/media/main5_zh_768-min.2df99138.png";